import { base } from '../base';

export const fieldType = `${base}/FieldType`;
